"use client";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { LoginMethodTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useState } from "react";
import SocialButtons from "../auth-common/auth-social/SocialButtons";
import AuthTabs from "../auth-common/auth-tabs/AuthTabs";
import AuthContainer from "../auth-common/auth-container/AuthContainer";
import AuthRedirectTo from "../auth-common/AuthRedirectTo";
import RegisterForm from "./RegisterForm";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useSearchParams } from "next/navigation";

interface Props {
  reference_id?: number | null;

  isFromCheckout?: boolean;
  onClickBack?: () => void;
  setTab?: () => void;
}

const Register: React.FC<Props> = ({
  reference_id,
  isFromCheckout,
  onClickBack,
  setTab,
}) => {
  const getCompany = useGetCompanyQuery();
  const company = getCompany?.data?.result;
  const customer_login_methods =
    company?.theme?.settings?.customer_login_methods;
  const t = useTranslation();
  const searchParams = useSearchParams();
  const [btnIndex, setBtnIndex] = useState<LoginMethodTypes>();
  const cn = `register-sub-container`;
  const isFromCart = searchParams.get("fromCart");
  const goToAuthFromPage = (from?: "fromCart" | "fromCheckout") => {
    if (!from) return "";
    const params = new URLSearchParams(searchParams.toString());
    params.set(from, "true");
    return "?" + params.toString();
  };
  const href =
    PagesPaths.signin +
    goToAuthFromPage(
      isFromCart ? "fromCart" : isFromCheckout ? "fromCheckout" : undefined,
    );
  return (
    <AuthContainer
      title={t.register}
      className={cn}
      onClickBack={onClickBack}
      isFromCheckout={isFromCheckout}
    >
      {customer_login_methods === LoginMethodTypes.any ? (
        <div className={cn + "w-100"}>
          <AuthTabs btnIndex={btnIndex} setBtnIndex={setBtnIndex} />
        </div>
      ) : (
        <></>
      )}
      <RegisterForm
        reference_id={reference_id!}
        registerBy={btnIndex ?? LoginMethodTypes.both}
        className={cn}
        isFromCheckout={isFromCheckout}
      />
      <div className={cn}>
        <SocialButtons />
        <AuthRedirectTo
          text={t.already_have_an_account}
          authLink={{
            text: t.sign_in,
            href,
          }}
          onClick={setTab}
        />
      </div>
    </AuthContainer>
  );
};

export default Register;
